import {Btn, BtnWrap, Text, Container, Link, LinkWrap, Title} from "./styled";
import {ParallaxBackground} from "../ParallaxBackground/ParallaxBackground";
import {useImageUrl} from "../../../queries";

export const Basement = ({back, data}) => {
    const aboutUs = data?.about_us || {};
    const title = aboutUs?.title || '';
    const addressLine = aboutUs?.address_line || '';
    const addressEmail = aboutUs?.address_email || '';
    const addressPhone = aboutUs?.address_phone || '';
    const buttons = aboutUs?.buttons || [];
    const basementImageUrl = useImageUrl(data?.about_us?.background);

    return (
        <Container>
            <ParallaxBackground
                imageUrl={basementImageUrl || ""}
                speedFactor={-0.2}
                height={'100%'}
                back={back}
            />
            <Title>{title}</Title>
            <LinkWrap>
                {addressLine && (
                    <Text>
                        <Link target='_blank' href={buttons[0]?.href || '#'}>{addressLine}</Link>
                    </Text>
                )}
                {addressEmail && (
                    <Text>
                        {addressEmail.split(':')[0]}: <Link
                        href={`mailto:${addressEmail.split(':')[1]?.trim()}`}>{addressEmail.split(':')[1]?.trim()}</Link>
                    </Text>
                )}
                {addressPhone && (
                    <Text>
                        {addressPhone.split(':')[0]}: <Link
                        href={`tel:${addressPhone.split(':')[1]?.trim()}`}>{addressPhone.split(':')[1]?.trim()}</Link>
                    </Text>
                )}
            </LinkWrap>
            {buttons.length > 0 && (
                <BtnWrap>
                    {buttons.map((button, index) => (
                        <Btn key={index} as="a" href={button.href || ""}
                             target={button.href?.startsWith('http') ? '_blank' : undefined}>
                            {button.title || ""}
                        </Btn>
                    ))}
                </BtnWrap>
            )}
        </Container>
    )
}
